<template>
  <div class="stockApp">
    <div class="stock">
      <Header class="headerTop"></Header>
      <main>
        <div class="mainTop">
          <div class="underHeader">
            <img src="../../assets/img/info.png" alt />
            当前位置：
          </div>
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="width:50%;height: 54px;display: inline-block;line-height: 54px;"
          >
            <el-breadcrumb-item :to="{ path: '/' }">平台首页</el-breadcrumb-item>
            <el-breadcrumb-item v-if="$route.params.dbcode==2" @click="intoMarket()">上市公司</el-breadcrumb-item>
            <el-breadcrumb-item v-else @click="medical()">医药企业</el-breadcrumb-item>
            <el-breadcrumb-item>{{companyFullName}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="mainBottom">
          <!-- 左侧菜单栏 -->
          <Left></Left>
          <!-- 右侧内容 -->
          <router-view class="addRight"></router-view>
        </div>
      </main>
      <Footer class="footerBottom"></Footer>
    </div>
  </div>
</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import Left from "@/components/left";
import api from "@/../static/common/api/api.js";

export default {
  props: {},
  components: {
    Header,
    Footer,
    Left
  },
  data() {
    return {
      companyFullName: "" //公司名
    };
  },
  computed: {},
  methods: {
    showName() {
      let creditCode = this.$route.query.creditCode;
      if (creditCode) {
        api.baseInfoTableCompanyDetail(creditCode).then(res => {
          this.companyFullName = res.data[0].companyFullName;
          sessionStorage.setItem(
            "stockCode",
            JSON.stringify(res.data[0].companyStockCode)
          );
          sessionStorage.setItem(
            "enterpriseCode",
            JSON.stringify(res.data[0].enterpriseCode)
          );
        });
      }
    },

    // 库 上市
    intoMarket() {
      this.$router.push({
        path: "/upmarket",
        query: {
          dbcode: 2
        }
      });
    },
    // 库 医药
    medical() {
      this.$router.push({
        path: "/pharma",
        query: {
          dbcode: 1
        }
      });
    }
  },
  created() {},
  mounted() {
    this.showName();
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/tableScrollbar.less";
@import "../../assets/less/style.less";
.stockApp {
  display: flex;
  background: url("../../assets/img/bg.png") no-repeat top;
}
.stock {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
main {
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  // background: #f4f4f4;
  // background: #adadb15b;
  .mainTop {
    display: flex;
    .underHeader {
      display: inline-block;
      height: 54px;
      line-height: 54px;
      padding-left: 19px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #dfecf7;
      img {
        width: 12px;
        height: 16px;
      }
    }
    /deep/ .el-breadcrumb__inner {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #dfecf7;
    }
    /deep/ .el-breadcrumb__inner:hover {
      color: #dfecf7;
    }
  }
  .mainBottom {
    width: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px 0px 20px;
    .addRight {
      // height: 100vh;
      overflow: auto;
    }
  }
}
</style>
 


// WEBPACK FOOTER //
// src/view/stock/index.vue